export default __webpack_public_path__ + "static/media/fhpCoinImage.53f050c9.jpg";